
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.042 1.272a.443.443 0 01.581-.237h0l2.422 1.019c.013.006.03.013.042.02h0l.01.006c.007.003.017.01.026.016h0l.02.017c.003.003.01.006.013.01.01.006.017.013.023.02l.02.019h0l.01.01h0l.01.01c.003.006.01.013.013.02h0l.01.016.01.016c.006.007.01.013.013.02.003.003.003.01.006.013.007.01.01.017.013.026 0 .004.004.01.004.014l.01.03h0l.003.016h0l.006.026h0l.004.03a.202.202 0 01.007.06v1.556l11.163 1.54c.007 0 .01.004.013.004.01 0 .017 0 .027.003.003 0 .01.004.016.004a.06.06 0 01.023.006h0l.02.007.02.01.039.02c.006.006.013.01.02.012l.008.005h0c.015.009.021.015.028.018l.016.014h0l.017.016c.003.003.01.007.013.013.003.007.01.01.013.017.003.006.01.01.013.016.007.007.01.01.013.016.003.007.01.014.013.02h0l.01.017h0l.01.02.01.016c.003.01.006.016.01.023h0l.01.03h0l.003.01c.003.009.003.016.006.022 0 .007.004.013.004.02l.003.023c.003.006.003.013.003.02v3.745c0 .999-.815 1.813-1.813 1.813h0H5.24c-.338 0-.657-.092-.926-.25h0v1.203c0 .51.414.927.926.927h8.378c.986 0 1.79.805 1.79 1.79 0 .986-.804 1.79-1.79 1.79-.985 0-1.79-.8-1.79-1.79 0-.328.088-.637.246-.903h0-3.988c.157.263.246.575.246.903 0 .986-.805 1.79-1.79 1.79-.986 0-1.791-.8-1.791-1.79 0-.335.095-.65.256-.92a1.816 1.816 0 01-1.58-1.797h0V2.76l-2.149-.907a.443.443 0 01-.236-.581zm5.503 13.017a.907.907 0 00-.904.903c0 .496.408.903.904.903a.905.905 0 00.903-.903c0-.5-.407-.903-.903-.903zm7.077 0a.907.907 0 00-.904.903c0 .496.407.903.904.903a.905.905 0 00.903-.903c0-.5-.407-.903-.903-.903zm-9.308-9.37v.109l2.384.218-2.384-.328z","fill":"#000","fill-rule":"nonzero","stroke":"#000","stroke-width":".5"}})])
          )
        }
      }
    